import React, { useEffect, useState } from "react";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import { Button, Table } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import RAPA_EAL_ICF from "../../../../src/assets/docs/RAPA_EAL_ICF.pdf";
import App_user_Guide from "../../../../src/assets/docs/11132024_RAPA_App_v2.pptx"
import $ from "jquery";
const Resources = () => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);

  useEffect(() => {
    if ($(window).width() < 600) {
      $("#sidebar").removeClass("show-sidebar").addClass("hide-sidebar");
    } else {
      $("#sidebar").removeClass("hide-sidebar").addClass("show-sidebar");
    }
    const handleResize = () => {
      setIsSidebarVisible(window.innerWidth >= 600);
    };
    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const columns = [
    { title: "Document", dataIndex: "document", key: "document" },
    { title: "Version", dataIndex: "version", key: "version" },
    { title: "Last Updated", dataIndex: "lastUpdated", key: "lastUpdated" },
    {
      title: "Actions",
      key: "path",
      render: (_, record) =>
        record.path && record.path !== "#" ? (
          <Button icon={<DownloadOutlined />} type="primary" outline={false} href={record.path} style={{color:"white"}} download>
            Download
          </Button>
        )
        :
        (<Button icon={<DownloadOutlined />} type="primary">
            Download
          </Button>)
    },
  ];

  const data = [
    {
      key: "1",
      document: "EverythingALS Digital Monitoring Segment Study Informed Consent",
      version: "1.0",
      lastUpdated: " 09-30-2022",
      path: RAPA_EAL_ICF,
    },
    {
      key: "2",
      document: "EverythingALS App User Guide",
      version: "1.0",
      lastUpdated: "11-13-2024",
      path:App_user_Guide
    },
    {
      key: "3",
      document: "EverythingALS Site SIV Guidance",
      version: "-",
      lastUpdated: "-",
      path:"#"
    },
    {
      key: "4",
      document: "EverythingALS Remote Monitoring Onboarding (Participant Facing)",
      version: "-",
      lastUpdated: "-",
      path:"#"
    },
    // Add other documents here
  ];

  return (
    <div className="participant-activity-div radcliff-participant-page">
      <Header />
      <div className="row">
        <Sidebar isVisible={isSidebarVisible} />
        <div className="col-lg-10 participant-right-section-wrapper">
          <div className="row">
            <div className="inner-wrapper">
              <div className="row top-space">
                <div className="col-lg-1"></div>
                <div className="col-lg-11">
                  <div className="ambassador-heading-section mb-3">
                    <h3 className="mb-3">Resources</h3>
                  </div>
                </div>
              </div>
              <div className="content">
                <div style={{ width: "100%" }}>
                  <div className="row participant-activity-table">
                    <div className="col-lg-11 mt-3" style={{ marginLeft: "auto" }}>
                      <Table
                        columns={columns}
                        dataSource={data}
                        pagination={false}
                        bordered
                        title={() => <div style={{ fontSize: "16px", textAlign: "left" }}>Study Materials</div>}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resources;